var kvSync_api = (Vue, config) => {
  let resource = null;
  const actions = {
    getValueByKey: {
      method: 'GET',
      url: `${config.kvSyncApiUrl}/api/aha-sync/kv`,
    },
    getValuesByPrefix: {
      method: 'GET',
      url: `${config.kvSyncApiUrl}/api/aha-sync/kv`,
    },
  };

  const initResource = () => {
    resource = Vue.resource('kv', {}, actions);
  };

  const getValueByKey = (key) => {
    return resource.getValueByKey({ key })
  };

  const getValuesByPrefix = (prefix) => {
    return resource.getValuesByPrefix({ prefix })
  };

  return {
    initResource,
    getValueByKey,
    getValuesByPrefix,
  }
};

const defaultSubscribeOptions = {
  once: false,
};

const KVSYNC_TOPIC_PREFIX = 'LS1';

class KvSyncSubscriber {
  constructor(mqttClient) {
    this.callbacks = {};
    this.client = mqttClient;
  }

  _isMatch(pattern, topic) {
    const regexPattern = pattern.replace(/#/g, '.*');
    const regex = new RegExp('^' + regexPattern + '$');
    return regex.test(topic)
  }

  _getCallbacks(key) {
    if (!key) {
      return []
    }
    if (!this.callbacks[key]) {
      const matchingCallbackKeys =
        Object.keys(this.callbacks).filter((callbackPattern) => this._isMatch(callbackPattern, key));
      if (matchingCallbackKeys.length > 0) {
        return this.callbacks[matchingCallbackKeys[0]]
      }
      return []
    }
    return this.callbacks[key]
  }

  _addCallback(key, callback) {
    if (!key) {
      throw new Error(`Can not add callback for following key: ${key}`)
    }
    if (!this.callbacks[key]) {
      this.callbacks[key] = [];
    }

    this.callbacks[key].push(callback);
  }

  _setCallback(key, callback) {
    if (!key) {
      throw new Error(`Can not set callback for following key: ${key}`)
    }
    this.callbacks[key] = [callback];
  }

  _removeCallbacks(key, callback) {
    const callbacks = this._getCallbacks(key);
    if (callback) {
      const idx = callbacks.indexOf(callback);
      if (idx > -1) {
        callbacks.splice(idx, 1);
      }
    } else {
      delete this.callbacks[key];
    }
  }

  extractTopicPrefix(topic) {
    const topicParts = topic.split('/');
    if (topicParts[1] === KVSYNC_TOPIC_PREFIX) {
      return topicParts.slice(2).join('/')
    }
    return topic
  }

  init() {
    this.client.on('message', (topic, message, packet) => {
      const callbacks = this._getCallbacks(topic);
      const topicWithoutPrefix = this.extractTopicPrefix(topic);
      callbacks.forEach((callback) => {
        callback(topicWithoutPrefix, message.toString(), packet);
      });
    });
  }

  subscribeKey(key, callback, options = defaultSubscribeOptions) {
    if (options.once) {
      this._setCallback(key, callback);
    } else {
      this._addCallback(key, callback);
    }
    this.client.subscribe(key);
  }

  unsubscribeKey(uri, callback) {
    this._removeCallbacks(uri, callback);
    this.client.unsubscribe(uri);
  }
}

const _state = {};

const actions = (kvSyncApi, kvSyncMqttSubscriber) => ({
  fetchValueByKeyAction: async ({ dispatch }, payload) => {
    if (!payload.key) return
    const value = await kvSyncApi.getValueByKey(payload.key);
    dispatch('updateKeyValueAction', {
      key: payload.key,
      value,
    });
  },
  subscribeKeyAction: async ({ dispatch }, payload) => {
    dispatch('fetchValueByKeyAction', payload.key);
    kvSyncMqttSubscriber.subscribeKey(payload.key, (topic, message) => {
      dispatch('updateKeyValueAction', {
        key: topic,
        value: message,
      });
      if (payload.callback) {
        payload.callback(topic, message);
      }
    }, payload.options);
  },

  updateKeyValueAction: () => { }, // only declare the action, plugins will listen to this to update state accordingly

  unsubscribeKeyAction(_, payload) {
    kvSyncMqttSubscriber.unsubscribeKey(payload);
  },
});

var kvSync_module = (kvSyncApi, kvSyncMqttSubscriber) => ({
  namespaced: true,
  state: _state,
  actions: actions(kvSyncApi, kvSyncMqttSubscriber),
});

export { kvSync_api as KvSyncApi, KvSyncSubscriber as KvSyncMqttSubscriber, kvSync_module as KvSyncVuexModule };
